var map = {
	"./clients/clients.module": [
		"../../../../../src/app/clients/clients.module.ts",
		"common",
		"clients.module"
	],
	"./cms/cms.module": [
		"../../../../../src/app/cms/cms.module.ts",
		"common",
		"cms.module"
	],
	"./components/auth/auth.module": [
		"../../../../../src/app/components/auth/auth.module.ts",
		"auth.module"
	],
	"./config/config.module": [
		"../../../../../src/app/config/config.module.ts",
		"common",
		"config.module"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./helpers/error/error.module": [
		"../../../../../src/app/helpers/error/error.module.ts",
		"common",
		"error.module"
	],
	"./issue/issue.module": [
		"../../../../../src/app/issue/issue.module.ts",
		"common",
		"issue.module"
	],
	"./logistics/logistics.module": [
		"../../../../../src/app/logistics/logistics.module.ts",
		"common",
		"logistics.module"
	],
	"./marketing/marketing.module": [
		"../../../../../src/app/marketing/marketing.module.ts",
		"common",
		"marketing.module"
	],
	"./pos/pos.module": [
		"../../../../../src/app/pos/pos.module.ts",
		"common",
		"pos.module"
	],
	"./products/products.module": [
		"../../../../../src/app/products/products.module.ts",
		"common",
		"products.module"
	],
	"./providers/providers.module": [
		"../../../../../src/app/providers/providers.module.ts",
		"common",
		"providers.module"
	],
	"./reports/reports.module": [
		"../../../../../src/app/reports/reports.module.ts",
		"common",
		"reports.module"
	],
	"./sales/sales.module": [
		"../../../../../src/app/sales/sales.module.ts",
		"common",
		"sales.module"
	],
	"./transconta/transconta.module": [
		"../../../../../src/app/transconta/transconta.module.ts",
		"common",
		"transconta.module"
	],
	"./transportadora/trans.module": [
		"../../../../../src/app/transportadora/trans.module.ts",
		"common",
		"trans.module"
	],
	"./transportadoraCliente/transC.module": [
		"../../../../../src/app/transportadoraCliente/transC.module.ts",
		"common",
		"transC.module"
	],
	"./users/users.module": [
		"../../../../../src/app/users/users.module.ts",
		"common",
		"users.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main